import VerifyCodeModal from './VerifyCodeModal';

export { VerifyCodeModal };
